// @ts-expect-error
import * as projectOperator from '@arcgis/core/geometry/operators/projectOperator';

type SpatialReferenceLike = {
  readonly wkid?: number;
  readonly latestWkid?: number;
};

let loadPromise: Promise<void> | null = null;

/** Ensure the client-side projection engine is ready */
export function loadProjectOperator(): Promise<void> {
  if (projectOperator.isLoaded) {
    return Promise.resolve();
  }
  if (!loadPromise) {
    loadPromise = Promise.resolve(projectOperator.load()).then(() => undefined);
  }
  return loadPromise;
}

/**
 * Project a geometry to an output spatial reference.
 * Replaces deprecated `@arcgis/core/geometry/projection` `.project()`.
 */
export function projectGeometry<T>(
  geometry: T,
  outSpatialReference: SpatialReferenceLike | unknown,
): T | null {
  try {
    if (!projectOperator.isLoaded) {
      void loadProjectOperator();
      return null;
    }
    const result = projectOperator.execute(geometry, outSpatialReference);
    return (result as T | null) ?? null;
  } catch {
    return null;
  }
}

/** Async project that always waits for the engine to load first. */
export async function projectGeometryAsync<T>(
  geometry: T,
  outSpatialReference: SpatialReferenceLike | unknown,
): Promise<T | null> {
  await loadProjectOperator();
  try {
    const result = projectOperator.execute(geometry, outSpatialReference);
    return (result as T | null) ?? null;
  } catch {
    return null;
  }
}
